export function formatCurrency(value) {
  // Round the value to two decimal places
  value = Math.round(value * 100) / 100;
  
  // Format the value as a currency
  return value.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
}


// utils.js
export function createSlug(name) {
  return name
    .toLowerCase()
    .replace(/á|ã|ä/g, "a")
    .replace(/é/g, "e")
    .replace(/í/g, "i")
    .replace(/ó|ö/g, "o")
    .replace(/ü/g, "u")
    .replace(/ç/g, "c")
    .replace(/ /g, "-")
    .replace(/[^\w-]+/g, "");
}
